{
	"letterhead": "Event '{{name}} ({{begin}})'",
	"notAuthorized": "You are not authorized to view any reports from this section"
}
